import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
const documento_tipo = new datos("documento_tipo");

export const getDocumentoTipos= async (auth) => {
  documento_tipo.addCondition("documento_tipo", "id", 0, ">");
  const response = await documento_tipo.get();
  return esArray(response.wsResponse.documento_tipo);
};

export const getDocumentoTiposPaginated = async (limit, offset) => {
  documento_tipo.addCondition("documento_tipo", "id", 0, ">");
  documento_tipo.addLimitCondition(limit, offset);
  const response = await documento_tipo.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: esArray(response.wsResponse.documento_tipo),
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const deleteDocumentoTipos = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este Tipo de Documento?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const documento_tipo = new datos("documento_tipo");
      let data = {
        id: id,
      };
      const response = await documento_tipo.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire(
          "Eliminado!",
          "El tipo de documento ha sido eliminado exitosamente",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    }
  });
  return status;
};